import { combineReducers } from "redux";
import {
  GET_DEALER_STORE_DT,
  GET_DEALER_STORE_DT_OK,
  GET_DEALER_STORE_DT_ERR,
  DO_DEALER_STORE_DT_CLEANUP,

  APPLY_DEALER_STORE_DT_FILTERS,
  CLEAR_DEALER_STORE_DT_FILTERS,

  GET_DEALER_STORE_LIST,
  GET_DEALER_STORE_LIST_OK,
  GET_DEALER_STORE_LIST_ERR,
  DO_DEALER_STORE_LIST_CLEANUP,

  GET_SUBSCRIPTION_DT,
  GET_SUBSCRIPTION_DT_OK,
  GET_SUBSCRIPTION_DT_ERR,
  DO_SUBSCRIPTION_DT_CLEANUP,
  GET_DEALER_REGION_STORE_LIST,
  GET_DEALER_GROUP_STORE_LIST,
} from "./actionTypes";

/********** DATATABLE **********/

const defaultDtState = {
  dealerStores: [],
  dealerStoresError: null,
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 50,
    page: 1,
    search: null,
    filters: null,
  },
  isLoadInProgress: false,
};

const Dt = (state = defaultDtState, action) => {
  switch (action.type) {
    case GET_DEALER_STORE_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        dealerStoresError: null,
        isLoadInProgress: true,
      };
      break
    case GET_DEALER_STORE_DT_OK:
      state = {
        ...state,
        dealerStores: action.payload.response.dealerStores,
        totalCount: action.payload.response.totalCount,
        isLoadInProgress: false,
      };
      break
    case GET_DEALER_STORE_DT_ERR:
      state = {
        ...state,
        dealerStores: [],
        totalCount: 0,
        dealerStoresError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_DEALER_STORE_DT_CLEANUP:
      state = {
        ...state,
        dealerStores: [],
        dealerStoresError: null,
      };
      break
  }
  return state;
}

/********** DATATABLE FILTERS **********/

const defaultDtFiltersState = {
  name: '',
  group: '',
  region: '',
  state: '',
  integrations: '',
  integrationsMode: "INC",
  createdBetween: '',
  paymentSetupStatus: '',
  isNew: '',
  isActive: '',
  isPowerDealerStore: '',
  successRepresentativeId: ''
};

const DtFilters = (state = defaultDtFiltersState, action) => {
  switch (action.type) {
    case APPLY_DEALER_STORE_DT_FILTERS:
      state = {
        ...defaultDtFiltersState, // we need to initialize `integrations` and `integrationsMode`
        ...action.payload.filters
      }
      break
    case CLEAR_DEALER_STORE_DT_FILTERS:
      state = { ...defaultDtFiltersState };
      break
  }
  return state;
}

/********* LIST *********/

const defaultListState = {
  stores: [],
  storesError: null,
  isLoadInProgress: false,
};

const List = (state = defaultListState, action) => {
  switch (action.type) {
    case GET_DEALER_GROUP_STORE_LIST:
    case GET_DEALER_REGION_STORE_LIST:
    case GET_DEALER_STORE_LIST:
      state = {
        ...state,
        storesError: null,
        isLoadInProgress: true,
      }
      break
    case GET_DEALER_STORE_LIST_OK:
      state = {
        ...state,
        stores: action.payload.response.dealerStores,
        isLoadInProgress: false,
      }
      break
    case GET_DEALER_STORE_LIST_ERR:
      state = {
        ...state,
        stores: [],
        storesError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_DEALER_STORE_LIST_CLEANUP:
      state = { ...defaultListState };
      break
  }
  return state;
}

/********* SUBSCRIPTIONS DATATABLE *********/

const defaultSubscriptionDtState = {
  subscriptions: [],
  subscriptionsError: null,
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 50,
    page: 1,
    search: null,
    filters: null,
  },
  isLoadInProgress: false,
};

const SubscriptionDt = (state = defaultSubscriptionDtState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTION_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        subscriptionsError: null,
        isLoadInProgress: true,
      };
      break
    case GET_SUBSCRIPTION_DT_OK:
      state = {
        ...state,
        subscriptions: action.payload.response.subscriptions,
        totalCount: action.payload.response.totalCount,
        isLoadInProgress: false,
      };
      break
    case GET_SUBSCRIPTION_DT_ERR:
      state = {
        ...state,
        subscriptions: [],
        subscriptionsError: action.payload.error,
        totalCount: 0,
        isLoadInProgress: false,
      };
      break
    case DO_SUBSCRIPTION_DT_CLEANUP:
      state = { ...defaultSubscriptionDtState };
      break
  }
  return state;
}

export default combineReducers({
  Dt,
  DtFilters,
  List,
  SubscriptionDt,
});